{
  "version": 1,
  "asset_id": "8226b4e6-6bb7-44a7-9bf2-34b7656949d7",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/8226b4e6-6bb7-44a7-9bf2-34b7656949d7/sylwia-nagroda.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/8226b4e6-6bb7-44a7-9bf2-34b7656949d7/sylwia-nagroda.jpg",
  "original_filename": "sylwia-nagroda.jpg",
  "size": 231703,
  "content_type": "image/jpeg",
  "created_at": "2026-08-27T07:44:20Z"
}
